











































































































































































































































































































































































































































import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class CoinRotateCenterIcon extends Vue {
  @Prop({ default: '66' }) readonly width?: string;
  @Prop({ default: '76' }) readonly height?: string;
}
